import script from "./Guidelines.vue?vue&type=script&setup=true&lang=js"
export * from "./Guidelines.vue?vue&type=script&setup=true&lang=js"

import "./Guidelines.vue?vue&type=style&index=0&id=7c345323&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c345323"]])

export default __exports__